export default __webpack_public_path__ + "static/media/sponsor-1.c2f29add.svg";